const toNumber = (value) => {
  const parsed = parseFloat(value);
  return Number.isFinite(parsed) ? parsed : undefined;
};

const AIR_MINI_UNIT_VARIANT = "BBM";

// UK Air 3 unit uses variant OR; US/CA/AU use BS.
const AIR3_UNIT_VARIANT_BY_REGION = {
  GB: "OR",
};

const getAir3UnitVariant = (regional) =>
  AIR3_UNIT_VARIANT_BY_REGION[regional] ?? "BS";

const parseUnitPricing = (item, fallbackDel) => {
  if (!item) return null;
  const base = toNumber(item.priceWithAutoRefill ?? item.price);
  if (base === undefined) return null;

  let del = null;
  if (fallbackDel != null) {
    const withoutAutoRefill = toNumber(item.priceWithoutAutoRefill);
    del =
      withoutAutoRefill !== undefined && withoutAutoRefill > base
        ? withoutAutoRefill
        : fallbackDel;
  }

  return { base, del };
};

export const getSocksPrice = (regionalPrices, variantCode) => {
  if (!Array.isArray(regionalPrices) || !variantCode) return undefined;
  const match = regionalPrices.find(
    (item) => item.variant === variantCode && !item.isUnit,
  );
  return match ? toNumber(match.price) : undefined;
};

export const getFilterPrice = (regionalPrices, variantCode) => {
  if (!Array.isArray(regionalPrices) || !variantCode) return undefined;
  const match = regionalPrices.find(
    (item) => item.variant === variantCode && !item.isUnit,
  );
  return match ? toNumber(match.price) : undefined;
};

export const getUnitPrice = (regionalPrices, variantCode) => {
  if (!Array.isArray(regionalPrices)) return undefined;
  const match = variantCode
    ? regionalPrices.find((item) => item.isUnit && item.variant === variantCode)
    : regionalPrices.find((item) => item.isUnit);
  return match ? toNumber(match.price) : undefined;
};

export const getUnitPriceForQty = (regionalPrices, variantCode, qty) => {
  const price = getUnitPrice(regionalPrices, variantCode);
  return price === undefined ? undefined : price * qty;
};

export const getCurrencyCode = (regionalPrices) => {
  if (!Array.isArray(regionalPrices) || regionalPrices.length === 0)
    return undefined;
  return regionalPrices[0]?.currencyCode;
};

/**
 * Resolves Mila Air 3 and Air Mini unit prices for header/sidebar UI.
 * Matches API items by isUnit + variant (region-specific for Air 3).
 * Falls back to static filterRegionSpecificPrices when API data is missing.
 */
export const getHeaderUnitPrices = (regionalPrices, regional, staticPrices) => {
  const fallback = staticPrices[regional] ?? staticPrices.US;
  const air3Variant = getAir3UnitVariant(regional);

  const resolve = (variant, key) => {
    const staticPrice = fallback[key];
    const parsed = parseUnitPricing(
      Array.isArray(regionalPrices)
        ? regionalPrices.find((item) => item.isUnit && item.variant === variant)
        : null,
      staticPrice.del,
    );

    return parsed ?? staticPrice;
  };

  return {
    air: resolve(air3Variant, "air"),
    airMini: resolve(AIR_MINI_UNIT_VARIANT, "airMini"),
    milaFilter: fallback.milaFilter,
    milaSocks: fallback.milaSocks,
  };
};
